import React from "react";
import { FaTimes } from "react-icons/fa";
import { v4 as uuid } from "uuid";
import icon2 from "assets/images/icons/clean-cash2.png";
import icon3 from "assets/images/icons/hst-final.png";
import Modal from "components/shared/Modal";
import { useDispatch, useSelector } from "react-redux";
import { useError } from 'ErrorProvider';

import { refreshAll,  performSafeMaintenance } from "BlockchainInteractionWax";

const MaintenanceForm = ({ isOpen, setIsOpen, ual, minMain, maxMain, assetId }) => {
  const dispatch = useDispatch();
  const { setError } = useError();

  async function performMaintenance()
  {
    await performSafeMaintenance(ual, assetId, setError)
    setIsOpen(false)
    await refreshAll(dispatch);
  }

  return (
    <Modal isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
      <div
        className="w-full rounded-xlpy-4 px-6 font-Montserrat"
        id="addslot_modal"
        style={{ backgroundImage: "radial-gradient(#292929, #000000)", border: "6px outset rgba(165, 165, 165, 0.4)" }}
      >
        <div>
          <div className="mb-2 flex items-center justify-between">
            <div />
            <div />
            <h2 className="px-5 py-2 text-center font-Montserrat text-2xl font-bold text-white">
              Maintenance cost
            </h2>
            <FaTimes
              className="block text-2xl text-white hover:cursor-pointer"
              onClick={() => setIsOpen(false)}
            />
          </div>
          <div className="flex justify-center">
            <div>
                <div
                  className="addslot-item flex items-center gap-x-3"
                >
                  <div className="w-12">
                    <img
                      src={icon2}
                      className="h-full w-full object-contain"
                      alt="Token Icon"
                    />
                  </div>
                  <p className="font-bold text-white">{(minMain*1.0).toFixed(2)}/{(maxMain*1.0).toFixed(2)}</p>
                </div>
                <div
                  className="addslot-item flex items-center gap-x-3"
                >
                  <div className="w-12">
                    <img
                      src={icon3}
                      className="h-full w-full object-contain"
                      alt="Token Icon"
                    />
                  </div>
                  <p className="font-bold text-white">{(minMain*0.6).toFixed(2)}/{(maxMain*0.6).toFixed(2)}</p>
                </div>
            </div>
          </div>
          <div className="mt-5 flex justify-center">
            <div className='buttonContainer '  >
              <button className="w-32 py-1 px-3" onClick={() => performMaintenance()}>
                Perform maintenance
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MaintenanceForm;
